import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from '@material-ui/lab';
import ErrorImage from '../../../../../../assets/buu.jpg';
import { useProductModalImageStyles } from './styles';

const ProductModalImage = ({ ...props }) => {
  const { src, mobile } = props;

  const classes = useProductModalImageStyles({ mobile });

  return (
    <>
      {!src && src !== 'error' && <Skeleton className={classes.skeleton} />}
      {src && src !== 'error' && (
        <img data-cy="productModalImage" className={classes.image} src={src} />
      )}
      {src && src === 'error' && (
        <img
          data-cy="errorModalImage"
          className={classes.image}
          src={ErrorImage}
        />
      )}
    </>
  );
};

ProductModalImage.propTypes = {
  src: PropTypes.string,
  mobile: PropTypes.bool,
};

export default ProductModalImage;
